/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentTemplateStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    ARCHIVED = 'ARCHIVED',
}
